<template>
  <p class="clearfix mb-0">
    <span class="float-md-left d-block d-md-inline-block mt-25">
      COPYRIGHT © {{ new Date().getFullYear() }}
      <b-link class="ml-25" href="https://myplaceup.com/" target="_blank"
        >MyPlaceUp</b-link
      >
      <span class="d-none d-sm-inline-block">, All rights Reserved</span>
    </span>

    <b-link
      :to="{ name: 'changelog' }"
      class="float-md-right d-none d-md-block mr-25"
    >
    Version 3.5.6
    </b-link>

    <span class="float-md-right d-none d-md-block mr-1"
      >Hand-crafted &amp; Made with
      <feather-icon
        icon="HeartIcon"
        size="21"
        class="stroke-current"
        style="color:#A7844E;"
      />
    </span>
  </p>
</template>

<script>
import { BLink } from 'bootstrap-vue'

export default {
  components: {
    BLink,
  },
}
</script>
